import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

const OnlineVistorsChat = ({ label, visitors }) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
 
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
        display: false,
      },
      title: {
        display: false,
        text: "Amount of Product Sold",
      },
    },
    scales: {
      y: {
        ticks: {
          stepSize: 100,
        },
        title: {
          display: false,
          text: "Sales (in $)",
        },
        grid: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    barThickness: 8,
    borderRadius: 2,
  };

  const labels = label.slice(0,-1);

  const data = {
    labels,
    datasets: [
      {
        data: visitors.slice(0,-1),
        borderColor: "#5887DE",
        backgroundColor: (color) => {
          color = color.index > 10 ? "#E2CCCC" : "#F2F2F2";
          return color;
        },
      },
    ],
  };

  return (
    <>
      <Bar height={200} width={200} data={data} options={options} />
    </>
  );
};

export default OnlineVistorsChat;
